export default __webpack_public_path__ + "static/media/core-bg.340541f3.jpg";